import { useContext, useEffect, useState } from "react";
import { TextField } from "@mui/material";

import Compare from "../../../../../images/Compare.svg";
import { useNavigate } from "react-router-dom";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import RightArrow from "../../../../../images/ArrowRight.svg";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import Approved from "../../../../../images/ApprovedRequest.svg";
import Rejected from "../../../../../images/RejectedRequest.svg";
import ApprovedStatus from "../../../../../images/ApprovedStatus.svg";
import RejectedStatus from "../../../../../images/RejectedStatus.svg";
import Modal from "react-modal";
import View from "./View";
import ViewStatus from "../../../../../images/ViewStatus.svg";
import Pending from "../../../../../images/PendingRequest.svg";
import ViewProgress from "../../../../../images/Progress.svg";

import {
  LicenseTypes,
  MaterialRequestStatus,
  Operation,
} from "../../../../../utils/Enum.types";
import { Keys, SpecialKeys } from "../../../../../utils/Enum.keys";
import {
  getModifiedScrollHeight,
  handleMUISelectEvent,
  toInputStandardDate,
  toIsoDate,
  toStandardCase,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";

import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../styles/AutocompleteStyles";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";

import { Title } from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";

import useUrlParams from "../../../../../customHooks/useUrlParams";

import ApprovedList, { formDates } from "./ApprovedList";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetMrfs } from "./queries/queries";
import {
  AtsMrfMst,
  AtsMrfMstEdge,
  AtsMrfMstOrderField,
  DeleteDraftMrfResult,
  DeleteDraftMrfVars,
  GetMrfsResult,
  GetMrfsVars,
  MrfQueryType,
} from "./queries/types";

import {
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import MessageModal from "../../../../../customComponents/MessageModal";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import { DeleteDraftMrf } from "./queries/mutations";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import LoadingModal from "../../../../pages/LoadingModal";
import Navbar from "../../../../common/layout/Navbar";
import { useHotKey } from "../../../../../utils/hotKeys";

export const enum materialRequestListHeaders {
  Date = "Date",
  Subsidary_Company = "Subsidary Company",
  Requested_By = "Requested Raised By",
  Item_Requested = "Total Item Requested",
  Quantity_Requested = "Total Quantity Requested",
}
interface Props {
  pageType: MaterialRequestStatus;
}
const List = ({ pageType }: Props) => {
  const navigate = useNavigate();
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approved, setApproved] = useState(false);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [materials, setMaterials] = useState<AtsMrfMstEdge[]>([]);
  const [searchData, setSearchData] = useState("");

  const [deleteId, setDeletedId] = useState(0);

  const { dispatch, state } = useContext(AppContext);

  
  const { customer_id, company_id, sub_id } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();

  const statusOptions = Object.values(MrfQueryType);

  const [GetMrfData, { data, loading, fetchMore }] = useLazyQuery<
    GetMrfsResult,
    GetMrfsVars
  >(GetMrfs);

  const [DeleteMrf, { loading: DeleteDraftMrfLoading }] = useMutation<
    DeleteDraftMrfResult,
    DeleteDraftMrfVars
  >(DeleteDraftMrf, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.DELETE,
      }),
  });

  const [filterStatus, setFilterStatus] = useState(MrfQueryType.ALL_MRFS);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);

  const { data: todaysDateData, serverDate } = useServerDateandTime();

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const [message, setMessage] = useState(emptyMessage);
  useEffect(() => {
    if (customer_id && state.ActiveFinYr)
      GetMrfData({
        variables: {
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: ROWS_PER_PAGE,
          queryType: filterStatus,
          start_date: toIsoDate(dates.startDate),
          end_date: toIsoDate(dates.endDate),
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfMstOrderField.MRF_NO,
          },
          name: searchData,
         
        },
      });
  }, [
    GetMrfData,
    customer_id,
    searchData,
    dates,
    filterStatus,
    dates,
    state.ActiveFinYr,
  ]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetMrfs.edges;
              const pageInfo = fetchMoreResult.GetMrfs.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetMrfs.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetMrfs: {
                  edges: [...materials, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetMrfs.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable) scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetMrfs.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = materials.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setMaterials(updatedNewData);
      } else {
        setMaterials(newData);
      }
      setEndCursor(data.GetMrfs.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  const getImageUrl = (node: AtsMrfMst) => {
    switch (node.acceptStatus) {
      case MaterialRequestStatus.PENDING:
        return `${Pending}`;
      case MaterialRequestStatus.INPROGRESS:
        return `${ViewProgress}`;
      case MaterialRequestStatus.REJECTED:
        return `${RejectedStatus}`;
      case MaterialRequestStatus.APPROVED:
        return `${ApprovedStatus}`;
      default:
        return `${ViewStatus}`;
    }
  };

  const formatText = (input: string) => {
    return input
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace("/\bw/g", (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };

  const handleDelete = async (id: number) => {
    setDeleteModal(false);
    if (customer_id) {
      if (state.ActiveFinYr) {
        DeleteMrf({
          variables: {
            customerId: customer_id,
            finYrId: state.ActiveFinYr.id,
            mrfId: id,
            
            user_details,
          },
          refetchQueries: [
            {
              query: GetMrfs,
              variables: {
                after: null,
                customerId: customer_id,
                finYrId: state.ActiveFinYr.id,
                first: ROWS_PER_PAGE,
                queryType: filterStatus,
                start_date: toIsoDate(dates.startDate),
                end_date: toIsoDate(dates.endDate),
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsMrfMstOrderField.MRF_NO,
                },
                name: searchData,
                
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.DeleteDraftMrf) {
            setMessage({
              flag: true,
              message: "Deleted successfully",
              operation: Operation.NONE,
            });
          }
        });
      } else {
        setMessage({
          flag: true,
          message: "Authentication failed",
          operation: Operation.NONE,
        });
      }
    } else {
      setMessage({
        flag: true,
        message: "Customer not found",
        operation: Operation.NONE,
      });
    }
  };
  useEffect(() => {
    if (todaysDateData && serverDate) {
      const getMonth = new Date(serverDate).getMonth();
      const getYear = new Date(serverDate).getFullYear();

      const firstDay = new Date(getYear, getMonth, 1); // First day of the month
      const lastDay = new Date(getYear, getMonth + 1, 0);

      setDates({
        endDate: lastDay.toString(),
        startDate: firstDay.toString(),
      });
    }
  }, [todaysDateData, serverDate]);

  useHotKey({
    handleFunc: () => {
      navigate(`/${customer_id}/company/${company_id}/material/add`);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>Material Request {filterStatus.toLowerCase().replace("_"," ")} </Title>
      <div className="material">
        <div className="material__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => setSearchData(e.target.value)}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              options={statusOptions}
              getOptionLabel={(option) => {
                return formatText(option as string);
              }}
              value={filterStatus}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              onChange={(event, newValue) =>
                setFilterStatus(newValue as MrfQueryType)
              }
              openOnFocus
              forcePopupIcon
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Status"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col-3 material__select--flex">
            <TextField
              label="Start Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              type="date"
              className=" material__select--date"
              value={toInputStandardDate(dates.startDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  startDate: e.target.value,
                });
              }}
            />
            <img src={Compare} alt="" />
            <TextField
              label="End Date"
              type="date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              className=" material__select--date"
              value={toInputStandardDate(dates.endDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  endDate: e.target.value,
                });
              }}
            />
          </div>
          {pageType === MaterialRequestStatus.PENDING ? (
            <></>
          ) : (
            <div className="col flex-end">
              <Button
                mode="addnew"
                onClick={() =>
                  navigate(
                    `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/material/add`
                  )
                }
              />
            </div>
          )}
        </div>
        <div className="material__list">
          <div
            className="material__list--header"
            id={`${
              filterStatus === MrfQueryType.PENDING_MRFS
                ? "bg-grey"
                : filterStatus === MrfQueryType.IN_PROGRESS_MRFS
                ? "bg-amber"
                : filterStatus === MrfQueryType.REJECTED_MRFS
                ? "bg-red"
                : filterStatus === MrfQueryType.APPROVED_MRFS
                ? "bg-green"
                : "bg-var"
            }`}
          >
            <span>
              {`Total ${
                filterStatus !== MrfQueryType.ALL_MRFS ? filterStatus : "All"
              } Requests`}
              :
            </span>
            <b>{data ? data.GetMrfs.totalCount : 0}</b>
          </div>
          <ul className="material__list--ul">
            {materials.map((res, index) => {
              return (
                <li key={index} className="material__list--li">
                  <div className="material__list--li--details">
                    <div className="material__list--li--flex">
                      {index + 1}.&nbsp;
                      <b>{res.node.mrfNo}</b>
                      {pageType === MaterialRequestStatus.PENDING ? (
                        <>
                          <span
                            className={`material__list--li--flex${
                              res.node.acceptStatus ===
                              MaterialRequestStatus.APPROVED
                                ? "--approved"
                                : res.node.acceptStatus ===
                                  MaterialRequestStatus.INPROGRESS
                                ? "--progress"
                                : res.node.acceptStatus ===
                                  MaterialRequestStatus.REJECTED
                                ? "--rejected"
                                : "--pending"
                            }`}
                          >
                            {res.node.acceptStatus}
                          </span>
                        </>
                      ) : (
                        <span className="material__list--li--flex--pending">
                          Pending
                        </span>
                      )}
                    </div>
                    <div className="material__list--li--grid">
                      <div>
                        <span>{materialRequestListHeaders.Date}</span>
                        <b>{toStandardDate(res.node.mrfDate)}</b>
                      </div>
                      <div>
                        <span>
                          {materialRequestListHeaders.Subsidary_Company}
                        </span>
                        <b>{res.node.subsidiary.name}</b>
                      </div>
                      <div>
                        <span>{materialRequestListHeaders.Requested_By}</span>
                        <b>{`${res.node.raisedByUserDetails.name}`}</b>
                      </div>
                      <div>
                        <span>{materialRequestListHeaders.Item_Requested}</span>
                        <b>{res.node.itemQty}</b>
                      </div>
                      <div>
                        <span>
                          {materialRequestListHeaders.Quantity_Requested}
                        </span>
                        <b>{res.node.totalQty}</b>
                      </div>
                    </div>
                  </div>
                  <div className="material__list--li--actions">
                    {pageType === MaterialRequestStatus.PENDING ? (
                      <div
                        className="material__list--li--actions--pending"
                        onClick={() =>
                          navigate(
                            `/${customer_id}/company/${company_id}/purchase/material/pending/${res.node.id}/view`
                          )
                        }
                      >
                        <img src={getImageUrl(res.node)} alt="/" />
                        <span>View</span>
                      </div>
                    ) : (
                      <div>
                        <span>Actions</span>

                        <div className="material__list--li--actions--flex">
                          <img
                            src={Edit}
                            alt="/"
                            onClick={() => {
                              navigate(
                                `/${customer_id}/company/${company_id}/purchase/material/${res.node.id}/edit`
                              );
                            }}
                          />
                          <img
                            src={Delete}
                            alt=""
                            onClick={() => {
                              setDeletedId(res.node.id);
                              setDeleteModal(!deleteModal);
                            }}
                          />
                        </div>
                      </div>
                    )}

                    <img
                      src={RightArrow}
                      alt=""
                      onClick={() => {
                        dispatch({
                          type: payloadTypes.SET_MRF_ID,
                          payload: {
                            mrfId: res.node.id,
                          },
                        });
                        setViewModal(!viewModal);
                      }}
                    />
                  </div>
                </li>
              );
            })}
            {/* {filteredData.map((res, index) => {
              return (
                <li key={index} className="material__list--li">
                  <div className="material__list--li--details">
                    <div className="material__list--li--flex">
                      {index + 1}.&nbsp;
                      <b>{res.title}</b>
                      {pageType === MaterialRequestStatus.PENDING ? (
                        <>
                          <span
                            className={`material__list--li--flex${
                              res.status === MaterialRequestStatus.APPROVED
                                ? "--approved"
                                : res.status ===
                                  MaterialRequestStatus.INPROGRESS
                                ? "--progress"
                                : res.status === MaterialRequestStatus.REJECTED
                                ? "--rejected"
                                : "--pending"
                            }`}
                          >
                            {res.status}
                          </span>
                        </>
                      ) : (
                        <span className="material__list--li--flex--pending">
                          Pending
                        </span>
                      )}
                    </div>
                    <div className="material__list--li--grid">
                      <div>
                        <span>{materialRequestListHeaders.Date}</span>
                        <b>{res.date}</b>
                      </div>
                      <div>
                        <span>
                          {materialRequestListHeaders.Subsidary_Company}
                        </span>
                        <b>{res.company}</b>
                      </div>
                      <div>
                        <span>{materialRequestListHeaders.Requested_By}</span>
                        <b>{res.raised_by}</b>
                      </div>
                      <div>
                        <span>{materialRequestListHeaders.Item_Requested}</span>
                        <b>{res.total_item}</b>
                      </div>
                      <div>
                        <span>
                          {materialRequestListHeaders.Quantity_Requested}
                        </span>
                        <b>{res.total_quantity}</b>
                      </div>
                    </div>
                  </div>
                  <div className="material__list--li--actions">
                    {pageType === MaterialRequestStatus.PENDING ? (
                      <div
                        className="material__list--li--actions--pending"
                        onClick={() =>
                          navigate(`/assets/purchase/material/pending/view`)
                        }
                      >
                        <img
                          src={
                            {
                              [MaterialRequestStatus.PENDING]: Pending,
                              [MaterialRequestStatus.INPROGRESS]: ViewProgress,
                              [MaterialRequestStatus.REJECTED]: RejectedStatus,
                              [MaterialRequestStatus.APPROVED]: ApprovedStatus,
                            }[res.status] || ViewStatus
                          }
                          alt=""
                        />

                        <span>View</span>
                      </div>
                    ) : (
                      <div>
                        <span>Actions</span>

                        <div className="material__list--li--actions--flex">
                          <img src={Edit} alt="" />
                          <img
                            src={Delete}
                            alt=""
                            onClick={() => setDeleteModal(!deleteModal)}
                          />
                        </div>
                      </div>
                    )}

                    <img
                      src={RightArrow}
                      alt=""
                      onClick={() => setViewModal(!viewModal)}
                    />
                  </div>
                </li>
              );
            })} */}
          </ul>
        </div>
        <div className=" row g-0">
          <div className="col">
            <Button mode="back" onClick={() => navigate(-1)} />
          </div>
          {/* <div className="col material__footer">
            <div onClick={() => setApproved(!approved)}>
              <img src={Approved} alt="" />
              <span className="font-green">0</span>
            </div>
            <div>
              <img src={Rejected} alt="" />
              <span className="font-red">0</span>
            </div>
          </div> */}
        </div>
      </div>

      <Modal isOpen={viewModal} ariaHideApp={false} style={AddModalStyles}>
        <View setModalFlag={setViewModal} />
      </Modal>
      <Modal isOpen={approved} ariaHideApp={false} style={AddModalStyles}>
        <ApprovedList
          setModalFlag={setApproved}
          pageType={MrfQueryType.APPROVED_MRFS}
          showFilter={false}
          isMrfselect={false}
        />
      </Modal>

      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />

      <DeleteModal
        id={deleteId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />

      <LoadingModal flag={(!searchData && loading) || DeleteDraftMrfLoading} />
    </>
  );
};

export default List;
